(function() {

    'use strict';

    var ApiClient = function ApiClient() {};

    ApiClient.prototype.checkStatus = function(response) {

        if (response.status >= 200 && response.status < 300) {
            return response;
        }

        var error = new Error(response.statusText);
        error.response = response;

        throw error;

    };

    ApiClient.prototype.performRequest = function(method, url, body, headers) {

        if(headers === undefined) {

            headers = {
                'Accept': 'application/javascript',
                'Content-Type': 'application/json'
            };

        }

        headers['X-CSRF-Token'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

        var request = {
            method: method,
            credentials: 'same-origin',
            headers: headers
        };

        if(body) {
            request.body = body;
        }

        return fetch(url, request).then(this.checkStatus);

    };

    ApiClient.prototype.patch = function(url, body, headers) {
        return this.performRequest('PATCH', url, body, headers);
    };

    ApiClient.prototype.post = function(url, body, headers) {
        return this.performRequest('POST', url, body, headers);
    };

    ApiClient.prototype.get = function(url, headers) {
        return this.performRequest('GET', url, null, headers);
    };

    window.api = new ApiClient();

})();